export function getCurrentFormattedTime() {
  const date = new Date();

  const year = date.getUTCFullYear();
  const month = pad(date.getUTCMonth() + 1, 2); // 月份从0开始，所以需要加1
  const day = pad(date.getUTCDate(), 2);
  const hours = pad(date.getUTCHours(), 2);
  const minutes = pad(date.getUTCMinutes(), 2);
  const seconds = pad(date.getUTCSeconds(), 2);
  const milliseconds = pad(date.getUTCMilliseconds(), 3);

  // 拼接成符合要求的格式
  const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}000+0000`;

  return formattedDate;
}

function pad(number, length) {
  let str = '' + number;
  while (str.length < length) {
    str = '0' + str;
  }
  return str;
}
